module.exports = __webpack_public_path__ + "static/media/eq.80a48acc.PNG";